<template>
    <v-card :id="id" color="grey lighten-2 fill-height">
        <psi-card-heading
            :headingTitle="title"
            :icon="icon"
            :heading-color="headingColor"
        ></psi-card-heading>
        <v-card-text class="d-flex mt-2 fill-height">
            <v-avatar size="100" class="mr-2">
                <img
                    :src="instructor.profile_photo_url"
                    height="60"
                    width="60"
                />
            </v-avatar>
            <div>
                <h3 class="mb-2">
                    {{ instructor.name }}
                </h3>
                <div class="d-flex">
                    <v-icon class="mr-2">mdi-email</v-icon>
                    <a :href="`mailto:${instructor.email}`">{{
                        instructor.email
                    }}</a>
                </div>
                <div
                    class="d-flex mt-2"
                    v-if="$_.get(instructor, 'contact.phone', '')"
                >
                    <v-icon class="mr-2">mdi-phone</v-icon>
                    <a :href="`tel:${instructor.contact.phone}`">{{
                        instructor.contact.phone
                    }}</a>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "student-instructor",
    components: {},
    props: {
        instructor: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: "Instructor",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-account-box",
        },
        headingColor: {
            type: String,
            required: false,
            default: "primary",
        },
        id: {
            type: String,
            required: false,
            default: "student-instructor",
        },
    },
    data() {
        return {};
    },
    computed: {},
};
</script>

<style scoped>
</style>